import React from "react";
import styles from "./TextLabelValue.module.scss";
// @ts-ignore
import classNames from "classnames";

export enum TextLabelValueEnum {
  Primary = "primary",
  Secondaty = "secondary",
}

type PropsType = {
  variant?: TextLabelValueEnum;
  label: string;
  value?: string;
  className?: string;
  children?: React.ReactNode;
};

const TextLabelValue = (props: PropsType) => {
  return (
    <div
      className={classNames(
        styles.wrapper,
        props.className,
        props.variant && styles[props.variant]
      )}
    >
      <p className={classNames(styles.label)}>{props.label}</p>

      {props.children ? (
          <p data-cy={props.label}>{props.children}</p>
      ) : (
        <p className={classNames(styles.value)}>{props.value}</p>
      )}
    </div>
  );
};

TextLabelValue.Variants = TextLabelValueEnum;

export default TextLabelValue;
